import TableResults from '../components/result/TableResults';
import './stylePage.css';



function ResultsPage() {
    
    
        return (
                <div className='title'>
                    <div className='containerMarginTable'>
                        <TableResults />
                    </div>
                </div>
        );
}

export default ResultsPage;